/* Constants */

const production = {
  urls: {
    /* Need to swap api_base_url before pushing to production */
    api_base_url: 'https://globe-messaging.lawaapp.com/api/api/v1', // Staging server
    // api_base_url: 'https://sms-api.globe.my/api/v1', // Production server
    api_messages_documentation: 'https://www.google.com/',
  },

  // REDUX STORE PERSIST CONFIG
  persistConfig: {
    key: 'GLOBE-EM-PROD',
  },

  sentry: {
    env: 'production',
    dsn: 'https://730f9ba1366340eaab8e2220712efa73@o252633.ingest.sentry.io/5863703',
  },

  messageStatus: [
    { label: 'Success', value: 'delivered' },
    { label: 'Failed', value: 'failed' },
    { label: 'Pending', value: 'pending' },
  ],

  utc: [
    { label: '-12', value: '-12' },
    { label: '-11', value: '-11' },
    { label: '-10', value: '-10' },
    { label: '-9', value: '-9' },
    { label: '-8', value: '-8' },
    { label: '-7', value: '-7' },
    { label: '-6', value: '-6' },
    { label: '-5', value: '-5' },
    { label: '-4', value: '-4' },
    { label: '-3', value: '-3' },
    { label: '-2', value: '-2' },
    { label: '-1', value: '-1' },
    { label: '0', value: '0' },
    { label: '+1', value: '+1' },
    { label: '+2', value: '+2' },
    { label: '+3', value: '+3' },
    { label: '+4', value: '+4' },
    { label: '+5', value: '+5' },
    { label: '+6', value: '+6' },
    { label: '+7', value: '+7' },
    { label: '+8', value: '+8' },
    { label: '+9', value: '+9' },
    { label: '+10', value: '+10' },
    { label: '+11', value: '+11' },
    { label: '+12', value: '+12' },
  ],

  months: [
    { value: '1', month: 'Jan' },
    { value: '2', month: 'Feb' },
    { value: '3', month: 'Mar' },
    { value: '4', month: 'Apr' },
    { value: '5', month: 'May' },
    { value: '6', month: 'June' },
    { value: '7', month: 'July' },
    { value: '8', month: 'Aug' },
    { value: '9', month: 'Sept' },
    { value: '10', month: 'Oct' },
    { value: '11', month: 'Nov' },
    { value: '12', month: 'Dec' },
  ],

  msClientID: 'abc9c993-df5d-48a0-9448-ff0e5a446968',
};

const development = {
  urls: {
    api_base_url: 'http://10.90.24.200:8013/api/v1', // Staging server
    api_messages_documentation: 'https://www.google.com/',
  },

  // REDUX STORE PERSIST CONFIG
  persistConfig: {
    key: 'GLOBE-EM-DEV',
  },

  sentry: {
    env: 'development',
    dsn: 'https://730f9ba1366340eaab8e2220712efa73@o252633.ingest.sentry.io/5863703',
  },

  messageStatus: [
    { label: 'Success', value: 'delivered' },
    { label: 'Failed', value: 'failed' },
    { label: 'Pending', value: 'pending' },
  ],

  utc: [
    { label: '-12', value: '-12' },
    { label: '-11', value: '-11' },
    { label: '-10', value: '-10' },
    { label: '-9', value: '-9' },
    { label: '-8', value: '-8' },
    { label: '-7', value: '-7' },
    { label: '-6', value: '-6' },
    { label: '-5', value: '-5' },
    { label: '-4', value: '-4' },
    { label: '-3', value: '-3' },
    { label: '-2', value: '-2' },
    { label: '-1', value: '-1' },
    { label: '0', value: '0' },
    { label: '+1', value: '+1' },
    { label: '+2', value: '+2' },
    { label: '+3', value: '+3' },
    { label: '+4', value: '+4' },
    { label: '+5', value: '+5' },
    { label: '+6', value: '+6' },
    { label: '+7', value: '+7' },
    { label: '+8', value: '+8' },
    { label: '+9', value: '+9' },
    { label: '+10', value: '+10' },
    { label: '+11', value: '+11' },
    { label: '+12', value: '+12' },
  ],

  months: [
    { value: '1', month: 'Jan' },
    { value: '2', month: 'Feb' },
    { value: '3', month: 'Mar' },
    { value: '4', month: 'Apr' },
    { value: '5', month: 'May' },
    { value: '6', month: 'June' },
    { value: '7', month: 'July' },
    { value: '8', month: 'Aug' },
    { value: '9', month: 'Sept' },
    { value: '10', month: 'Oct' },
    { value: '11', month: 'Nov' },
    { value: '12', month: 'Dec' },
  ],

  msClientID: 'abc9c993-df5d-48a0-9448-ff0e5a446968',
};

const config =
  process.env.NODE_ENV === 'development' ? development : production;

export default config;
